import { useEffect, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context';
import { LoginForm } from '../components';
import { Card, Button } from '../components/common';
import './LoginPage.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, userStatus, isAdmin } = useAuth();
  const [loginSuccess, setLoginSuccess] = useState(false);

  const handleRedirectBasedOnStatus = useCallback((status) => {
    if (isAdmin()) {
      navigate('/admin');
    } else {
      navigate('/dashboard');
    }
  }, [isAdmin, navigate]);

  useEffect(() => {
    if (isAuthenticated) {
      handleRedirectBasedOnStatus(userStatus);
    }
  }, [isAuthenticated, userStatus, handleRedirectBasedOnStatus]);

  const handleLoginSuccess = (result) => {
    setLoginSuccess(true);
    setTimeout(() => {
      handleRedirectBasedOnStatus(result.userStatus);
    }, 1500);
  };

  return (
    <div className="login-page">
      <Card className="login-card" padding="lg">
        <Card.Header className="login-header">
          <Card.Title as="h1" className="login-title">로그인</Card.Title>
        </Card.Header>
        
        <Card.Content>
          {loginSuccess && (
            <div className="success-message">
              <div className="success-icon">✅</div>
              <div className="success-content">
                <div className="success-text">로그인 성공!</div>
                <div className="success-detail">대시보드로 이동 중입니다...</div>
              </div>
            </div>
          )}
          
          <LoginForm onSuccess={handleLoginSuccess} />
        </Card.Content>
        
        <Card.Footer className="login-footer">
          <p className="signup-link">
            계정이 없으시나요? 
            <Button 
              onClick={() => navigate('/register')}
              variant="primary"
              size="sm"
              className="signup-button"
            >
              회원가입
            </Button>
          </p>
        </Card.Footer>
      </Card>
    </div>
  );
};

export default LoginPage;